<template>
  <div
    v-if="showBanner"
    class="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50"
  >
    <div class="modern-banner">
      <button
        v-if="!showAnimation"
        class="close-button"
        @click="close"
        aria-label="Fermer"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <div class="banner-content" :class="{'no-close-button': showAnimation}">
        <slot name="dynamic-content" />
        <slot v-if="showAnimation" name="spinner">
          <div class="modern-spinner" />
        </slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent, ref} from 'vue';

export default defineComponent({
  name: 'HitBanner',
  props: {
    showAnimation: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  setup() {
    const showBanner = ref(true);

    return {
      showBanner,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
});
</script>

<style scoped>
.modern-banner {
  background: linear-gradient(135deg, #00997c 0%, #1abc9c 100%);
  color: white;
  border-radius: 1rem;
  padding: 1rem 1.5rem;
  box-shadow: 0 10px 25px rgba(0, 153, 124, 0.3);
  backdrop-filter: blur(20px);
  position: relative;
  min-width: 400px;
  max-width: 600px;
  animation: slideInUp 0.4s ease-out;
  border: 1px solid rgba(255, 255, 255, 0.2);
  opacity: 0.95;
}

.close-button {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
}

.close-button:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
}

.close-button:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

.banner-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding-right: 2rem;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  line-height: 1.4;
}

.banner-content.no-close-button {
  padding-right: 0;
}

.modern-spinner {
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 2px solid white;
  width: 18px;
  height: 18px;
  animation: spin 1s linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-banner {
    margin: 0 1rem;
    min-width: 320px;
    max-width: calc(100vw - 2rem);
    padding: 0.875rem 1.25rem;
    border-radius: 1.25rem;
  }

  .banner-content {
    font-size: 0.8rem;
    padding-right: 1.75rem;
  }

  .close-button {
    width: 24px;
    height: 24px;
    top: 0.625rem;
    right: 0.625rem;
  }

  .close-button svg {
    width: 14px;
    height: 14px;
  }
}

@media (max-width: 480px) {
  .modern-banner {
    margin: 0 0.5rem;
    min-width: 280px;
    max-width: calc(100vw - 1rem);
    padding: 0.75rem 1rem;
    border-radius: 1rem;
  }

  .banner-content {
    font-size: 0.775rem;
    padding-right: 1.5rem;
  }
}
</style>
